// extracted by mini-css-extract-plugin
export default {"wheels":"styles_wheels__2THw6"};